import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BackendService } from '../../service/backend.service';
import { LoggedInUserInfo, UserService } from '../../service/user.service';
import { CardData, CardService } from '../../service/card.service';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { generateRefId } from '../../../../../common/refid-utils';
import { EXTEND_CARD_PURCHASE_REQUEST } from '../../service/gql_queries/purchase.gql';
import { HeaderComponent } from '../../main/header/header.component';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderComponent
  ],
  templateUrl: './extend.component.html',
  styleUrl: './extend.component.scss'
})
export class ExtendComponent implements OnInit {
  card: CardData | null = null;
  refNumber: string = generateRefId();
  form = new FormGroup({
    paymentMethod: new FormControl('bankTraksfer'),
    cardNumber: new FormControl(''),
    cardOwner: new FormControl(''),
    cardExpiryDate: new FormControl(''),
    cardCvv: new FormControl('')
  });
  private iccid: string | null = null;
  private extendCode: string | null = null;
  private userSub?: Subscription;
  private user: LoggedInUserInfo | null = null;

  constructor(
    private readonly backendService: BackendService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly cardService: CardService
  ) {
  }

  ngOnInit() {
    console.log('ActivatedRoute snapshot:', this.route.snapshot.url);
    console.log('Params:', this.route.snapshot.params);
    this.route.paramMap.subscribe(params => {
      console.log('ParamMap:', params);
    });
    // log stan zalogowania:
    console.log('Is user logged in:', this.userService.isUserLoggedIn());


    this.userSub = this.userService.userLoggedIn$.subscribe(async user => {
      if (!user) {
        await this.goToDashboard();
        return;
      }

      this.user = user;
      this.route.paramMap.subscribe(async params => {
        this.iccid = params.get('iccid');
        this.extendCode = params.get('code');
        if (!this.iccid || !this.extendCode || !this.userService.isUserLoggedIn()) {
          await this.goToDashboard();
          return;
        }
        await this.fetchCard(this.iccid);
      });
    });
  }

  ngOnDestroy() {
    this.userSub?.unsubscribe();
  }

  async fetchCard(iccid: string): Promise<void> {
    const fullCardInfo = await this.cardService.getCardDetails(iccid);
    if (!fullCardInfo || !fullCardInfo.card) {
      console.error(`No card information found for ICCID: ${iccid} => ${JSON.stringify(fullCardInfo)}`);
      await this.goToDashboard();
      return;
    }

    const isAdmin = this.user != null && this.user.groups.some(g => g === 'ADMINS');
    if (!isAdmin && (!fullCardInfo.card.userId || fullCardInfo.card.userId !== this.user?.userId)) {
      console.error(`User ${this.user?.username} is not authorized to extend card ${iccid}`);
      await this.goToDashboard();
      return;
    }

    this.card = fullCardInfo.card;
    console.log('card:', {
      ...this.card,
      pin1: '***',
      pin2: '***',
      puk1: '***',
      puk2: '***'
    });
  }

  async goToDashboard() {
    await this.router.navigate(["/"], {replaceUrl: true})
  }

  async proceedWithBankTransfer() {
    this.form.value.paymentMethod = 'bankTransfer';
    const registerStatus = await this.backendService.executeGraphQL(EXTEND_CARD_PURCHASE_REQUEST, {
        input: {
          iccid: this.iccid,
          productId: 'top-up',
          productName: this.extendCode || '',
          paymentMethod: this.form.value.paymentMethod || '',
          email: this.user?.email || '',
          username: this.user?.username || '',
          productPrice: 0,
          productPriceCurrency: 'PLN',
          refNumber: this.refNumber
        }
      }
    );
    console.info(`registerStatus: ${JSON.stringify(registerStatus)}`);
    const error = registerStatus.error ? `${registerStatus.error} / ${JSON.stringify(registerStatus.data)}` : '';
    if ((error != null && error !== '') || !registerStatus.data) {
      console.error(error);
    } else {
      await this.router.navigate(['/']);
    }

    console.log(`Proceeding with bank transfer payment`);
  }

  proceedWithCC() {
    this.form.value.paymentMethod = 'creditCard';
    const registrationData = {
      ...this.form.value
    };
    console.log('Proceeding with credit card payment' + JSON.stringify(registrationData, null, 2));
  }

  async resetToCardData() {
    console.log('Resetting to register');
    await this.router.navigate(['/card', this.iccid]);
  }
}
